<template>
  <div>
    <professional-base-info-block v-if="$store.state.appointmentRequest.profData" :profId="$store.state.appointmentRequest.initData.profId" :centerId="$store.state.appointmentRequest.profData.centerId" :rating="$store.state.appointmentRequest.profData.rating" :isFavourite="$store.state.appointmentRequest.profData.isFavourite" :customPageUrl="$store.state.appointmentRequest.profData.customPageUrl" :name="$store.state.appointmentRequest.profData.name" :surnames="$store.state.appointmentRequest.profData.surnames" :specialties="$store.state.appointmentRequest.profData.specialties" :introductoryText="$store.state.appointmentRequest.profData.introductoryText"
          :languages="$store.state.appointmentRequest.profData.languages" :photoUri="$store.state.appointmentRequest.profData.photoUri" :gender="$store.state.appointmentRequest.profData.gender" :subspecialties="$store.state.appointmentRequest.profData.subspecialties" @toggleIsFavourite="$store.state.appointmentRequest.profData.isFavourite = $event" :searchDisabled="$store.state.appointmentRequest.profData.searchDisabled"></professional-base-info-block>
    <appointment-request-init v-if="showStartView" class="mt-5" :profId="$store.state.appointmentRequest.initData.profId" :profSpecialtyId="$store.state.appointmentRequest.profData.specialties[0].id" :profConsultations="$store.state.appointmentRequest.profData.consultations" :profCenters="$store.state.appointmentRequest.profData.centers" :profTarifaPlusEnabled="$store.state.appointmentRequest.profData.tarifaPlus" :appointmentType="$store.state.appointmentRequest.initData.appointmentType" :serviceId="$store.state.appointmentRequest.initData.serviceId" :date="$store.state.appointmentRequest.initData.date" :centerId="$store.state.appointmentRequest.initData.centerId" :allowChatFirstAppointment="$store.state.appointmentRequest.appointmentData.allowChatFirstAppointment" 
    :associatedPets="$store.state.appointmentRequest.appointmentData.associatedPets" :associatedPatients="$store.state.appointmentRequest.appointmentData.associatedPatients" :companiesInfo="$store.state.appointmentRequest.appointmentData.companiesInfo" :ePrescription="$store.state.appointmentRequest.appointmentData.ePrescription" :profHolidaysDate="$store.state.appointmentRequest.appointmentData.profHolidaysDate" :isFirstAppointment="$store.state.appointmentRequest.appointmentData.isFirstAppointment"
    :isMedicalSpecialty="$store.state.appointmentRequest.appointmentData.medical" :minorRestricted="$store.state.appointmentRequest.appointmentData.minorRestricted" :parentalAdvisory="$store.state.appointmentRequest.appointmentData.parentalAdvisory" :includedInServicesPackages="$store.state.appointmentRequest.appointmentData.includedInServicesPackages" :profInsurers="$store.state.appointmentRequest.profData.insurers" :anyActiveChat="$store.state.appointmentRequest.appointmentData.anyActiveChat"
    :subscriptions="$store.state.appointmentRequest.appointmentData.subscriptions" :patientHasSpecialCompaniesPrices="$store.state.appointmentRequest.appointmentData.patientHasSpecialCompaniesPrices" :specialCompanyPriceRatio="$store.state.appointmentRequest.profData.specialCompanyPriceRatio" :profServicesPackages="$store.state.appointmentRequest.profData.servicesPackages" :patientPhoneInfo="$store.state.appointmentRequest.appointmentData.patientPhoneInfo" :chargeInplaceInPlatform="$store.state.appointmentRequest.profData.chargeInplaceInPlatform"
    :mustUpdateClinicHistory="$store.state.appointmentRequest.appointmentData.mustUpdateClinicHistory" :patientPendingCompanyAppointmentId="$store.state.appointmentRequest.appointmentData.patientPendingCompanyAppointmentId" :weightUpdated="$store.state.appointmentRequest.appointmentData.weightUpdated" :companiesInstantVideoPending="$store.state.appointmentRequest.appointmentData.companiesInstantVideoPending" @checkIfPaymentRequired="checkIfPaymentRequired"></appointment-request-init>
    <appointment-request-history-data v-if="showClinicHistoryView" @checkIfPaymentRequired="checkIfPaymentRequired"></appointment-request-history-data>
    <payment-view class="mt-5" v-if="showPaymentview" :paymentType="paymentType" :paymentDescription="paymentDescription" :price="$store.state.appointmentRequest.appointmentPrice" :copayment="$store.state.appointmentRequest.appointmentData.companiesInfo.copaymentEnabled" :ePrescriptionAvailable="$store.state.appointmentRequest.appointmentData.ePrescription" :appointmentData="getAppointmentData"
    :servicesPackageId="$store.state.appointmentRequest.formData.servicesPackageId" :profIdForWrittenFlatRate="$store.state.appointmentRequest.formData.profIdForWrittenFlatRate" :paymentsTypes="$store.state.appointmentRequest.appointmentData.paymentsTypes" @onFreeAppointmentOrBizumDirect="onFreeAppointmentOrBizumDirect($event)"></payment-view>
    <base-dialog v-model="modal.show" :content="modal.content" :okBtnText="modal.okBtnText" :okFn="modal.okFn" :cancelBtnText="modal.cancelBtnText" :cancelFn="modal.cancelFn"></base-dialog>
    <base-modal v-model="showChooseCompaniesQueueModal" noCloseOnBackdrop noCloseOnScape hideClose>
      <div :class="{'text-center': !$uiHelpers.isMobile}">
        <div v-html="$t('chooseQueueQuestion')"></div>
        <base-radio-group :stacked="$uiHelpers.isMobile" v-model="chooseQueueSelector.value" :options="chooseQueueSelector.options"></base-radio-group>
        <b-row class="mt-5">
            <b-col cols="12" class="text-center">
                <base-button @click="onQueueOptionSelected">{{ $t('accept') }}</base-button>
            </b-col>
        </b-row>
      </div>
    </base-modal>
  </div>
</template>

<script>
import ProfessionalBaseInfoBlock from '@/components/shared/ProfessionalBaseInfoBlock.vue'
import AppointmentRequestInit from './AppointmentRequestInit.vue'
import AppointmentRequestHistoryData from './AppointmentRequestHistoryData.vue'
import appointmentsRepository from '@/repositories/AppointmentsRepository'
import { PSYCHOLOGY_SPECIALTY_ID, CLINIC_PSYCHOLOGY_SPECIALTY_ID } from '@/constants/db/specialties'
import { INPLACE, VIDEO, CHAT, CALL, IMMEDIATE_VIDEO, SECOND_OPINION, INSURANCE, APPOINTMENT_REQUEST_TYPES, FLAT_RATE, SERVICES_PACKAGES, CONSULTATIONS_REQUIRE_PAYMENT, getConsultationTitleById } from '@/constants/consultationTypes'
import { APPOINTMENT as APPOINTMENT_PAYMENT, SERVICES_PACKAGES as SERVICES_PACKAGES_PAYMENT, FLAT_RATE as FLAT_RATE_PAYMENT } from '@/constants/paymentTypes'
import BaseModal from '@/components/base/BaseModal'
import PaymentView from '@/components/payment/PaymentView'
import BaseDialog from '@/components/base/BaseDialog'

const INIT_VIEW = 'appointmentRequest'
const CLINIC_HISTORY_VIEW = 'appointmentRequestClinicHistory'
const PAYMENT_VIEW = 'appointmentRequestPayment'
const QUEUE_OPTION_WAIT = 1
const QUEUE_OPTION_ANY = 2
const APPOINTMENTS_ROUTE = '/patient/appointments/next'
const URGENT_QUEUE_SPECIALTIES = [PSYCHOLOGY_SPECIALTY_ID, CLINIC_PSYCHOLOGY_SPECIALTY_ID]
const MAX_MINUTES_AGE_OF_DATA = 15

export default {
  components: {
    BaseModal,
    ProfessionalBaseInfoBlock,
    AppointmentRequestInit,
    AppointmentRequestHistoryData,
    PaymentView,
    BaseDialog
  },
  data () {
    return {
      promotionCode: null,
      bizumDirectPhone: null,
      showChooseCompaniesQueueModal: false,
      currentview: INIT_VIEW,
      modal: {
        show: false,
        content: null,
        okFn: null,
        okBtnText: null,
        cancelFn: null,
        cancelBtnText: null
      },
      chooseQueueSelector: {
        options: [ { value: QUEUE_OPTION_WAIT, text: this.$t('chooseQueue1') }, { value: QUEUE_OPTION_ANY, text: this.$t('chooseQueue2') } ],
        value: null
      }
    }
  },
  created () {
    if (this.$route.name === INIT_VIEW) {
      this.init()
    }
  },
  computed: {
    showStartView () {
      return (this.$store.state.appointmentRequest.profData && this.$store.state.appointmentRequest.appointmentData && this.$route.name === INIT_VIEW)
    },
    showClinicHistoryView () {
      return this.$route.name === CLINIC_HISTORY_VIEW && this.$store.state.appointmentRequest.appointmentData
    },
    showPaymentview () {
      return this.$route.name === PAYMENT_VIEW && this.$store.state.appointmentRequest.appointmentPrice
    },
    profSpecialty () {
      return this.$store.state.appointmentRequest.profData.specialties[0].id
    },
    appointmentType () {
      return this.$store.state.appointmentRequest.initData.appointmentType
    },
    freeAppointment () {
      return this.$store.state.appointmentRequest.appointmentPrice === 0
    },
    patientCompanyServiceActive () {
        return this.$store.state.appointmentRequest.appointmentData.companiesInfo.companiesServiceEnabled
    },
    paymentType () {
      if (this.$store.state.appointmentRequest.initData.appointmentType === FLAT_RATE) {
        return FLAT_RATE_PAYMENT
      } else if (this.$store.state.appointmentRequest.initData.appointmentType === SERVICES_PACKAGES || this.$store.state.appointmentRequest.formData.servicesPackageId) {
        return SERVICES_PACKAGES_PAYMENT
      } else {
        return APPOINTMENT_PAYMENT
      }
    },
    paymentDescription () {
      if (this.paymentType === APPOINTMENT_PAYMENT) {
        return getConsultationTitleById(this.$store.state.appointmentRequest.initData.appointmentType)
      } else {
        return null
      }
    },
    appointmentData () {
      return {
        professionalId: this.$store.state.appointmentRequest.initData.profId,
        centerId: this.$store.state.appointmentRequest.initData.centerId,
        fromDateTime: this.$store.state.appointmentRequest.formData.appointmentStartDate,
        toDateTime: this.$store.state.appointmentRequest.formData.appointmentEndDate,
        type: this.$store.state.appointmentRequest.initData.appointmentType,
        reason: this.$store.state.appointmentRequest.formData.reason,
        insurance: this.$store.state.appointmentRequest.formData.insurance,
        insuranceCardData: this.$store.state.appointmentRequest.formData.insuranceCardData,
        isFirstAppointment: this.$store.state.appointmentRequest.formData.isFirstAppointment,
        disease: this.$store.state.appointmentRequest.formData.disease.id,
        phoneNumberToCall: this.$store.state.appointmentRequest.formData.callInfo.phone,
        callPrefix: this.$store.state.appointmentRequest.formData.callInfo.prefix,
        rateRangeId: this.$store.state.appointmentRequest.initData.serviceId,
        queueDisabled: this.$store.state.appointmentRequest.queueDisabled,
        petId: this.$store.state.appointmentRequest.formData.pet,
        urgentQueue: this.$store.state.appointmentRequest.urgentQueue,
        foreignPatient: this.$store.state.appointmentRequest.formData.foreignPatient,
        shareClinicHistory: this.$store.state.appointmentRequest.formData.shareClinicHistory,
        shareClinicHistoryWithCenters: this.$store.state.appointmentRequest.formData.shareClinicHistoryWithCenters,
        specialtyId: this.$store.state.appointmentRequest.profData.specialties[0].id,
        files: this.$store.state.appointmentRequest.formData.files,
        links: this.$store.state.appointmentRequest.formData.links,
        nameAuthorizedForMinor: this.$store.state.appointmentRequest.formData.nameAuthorizedForMinor,
        promotionCode: this.promotionCode,
        bizumDirect: !!this.bizumDirectPhone
      }
    },
    getAppointmentData () {
      if (this.$store.state.appointmentRequest.formData.servicesPackageId || this.$store.state.appointmentRequest.formData.profIdForWrittenFlatRate) {
        return null
      } else {
        return this.appointmentData
      }
    }
  },
  methods: {
    init () {
      const initData = {
        profId: this.$route.query.profId,
        centerId: this.$route.query.centerId && this.$route.query.centerId !== 'null' ? this.$route.query.centerId : null,
        date: this.$route.query.date && this.$route.query.date !== 'null' ? new Date(this.$route.query.date) : null,
        serviceId: this.$route.query.serviceId && this.$route.query.serviceId !== 'null' ? this.$route.query.serviceId : null,
        appointmentType: APPOINTMENT_REQUEST_TYPES[this.$route.query.appointmentType]
      }
      if (!this.$store.state.appointmentRequest.profData || !this.$store.state.appointmentRequest.appointmentData || !this.checkInitSameData(initData)) {
        this.resetStoredData()
        this.$store.commit('appointmentRequest/setInitData', initData)
        const appointmentTypeMapped = typeof APPOINTMENT_REQUEST_TYPES[this.$route.query.appointmentType] === 'number' ? initData.appointmentType : null
        appointmentsRepository.getAppointmentRequestInfo({ profId: initData.profId, appointmentTypeId: appointmentTypeMapped, centerId: initData.centerId, serviceId: initData.serviceId, appointmentDate: initData.date }).then(response => {
          if (response.data) {
            this.$store.commit('appointmentRequest/setProfData', response.data.profInfo)
            this.$store.commit('appointmentRequest/setAppointmentData', response.data.appointmentInfo)
          }
        })
      }
    },
    checkInitSameData (data) {
      let storedAppointmentData = this.$store.state.appointmentRequest.initData
      if (!storedAppointmentData) {
        return false
      }
      const MAX_AGE_MS = MAX_MINUTES_AGE_OF_DATA * 60 * 1000
      const isExpired = Date.now() - storedAppointmentData.ts > MAX_AGE_MS
      if (isExpired) {
        return false
      }

      const keys = Object.keys(data)
      for (let key of keys) {
        const dataValue = data[key]
        const storedValue = storedAppointmentData[key]

        if (dataValue instanceof Date && storedValue instanceof Date) {
          if (dataValue.getTime() !== storedValue.getTime()) {
            return false
          }
        } else if (dataValue !== storedValue) {
          return false
        }
      }

      return true
    },
    resetStoredData () {
      this.$store.commit('appointmentRequest/reset')
    },
    checkIfPaymentRequired () {
      if (this.$store.state.appointmentRequest.initData.appointmentType === IMMEDIATE_VIDEO) {
        if (this.freeAppointment) {
            this.createAppointment()
        } else {
            this.initPayment()
        }
      } else if (this.$store.state.appointmentRequest.initData.appointmentType !== VIDEO && this.$store.state.appointmentRequest.initData.appointmentType !== SECOND_OPINION && this.patientCompanyServiceActive && this.$store.state.appointmentRequest.appointmentData.patientCanChooseQueue) {
        this.chooseQueueSelector.value = null
        this.showChooseCompaniesQueueModal = true
      } else if ((this.$store.state.appointmentRequest.initData.appointmentType === INPLACE && !this.$store.state.appointmentRequest.profData.chargeInplaceInPlatform) || this.$store.state.appointmentRequest.initData.appointmentType === INSURANCE || this.freeAppointment) {
        this.createAppointment()
      } else {
        this.initPayment()
      }
    },
    createAppointment () {
      appointmentsRepository.createAppointment(this.appointmentData).then(response => {
        if (response.data) {
          this.processAppointmentResult(response.data)
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    processAppointmentResult (data) {
      if (data && this.appointmentData.type === IMMEDIATE_VIDEO && this.patientCompanyServiceActive) {
        this.goToSuccessRoute({ companyQueue: true })
      } else if (!data) {
        this.goToErrorRoute()
      } else if (this.bizumDirectPhone) {
        this.$store.dispatch('payments/showBizumDirectConfirmDialog', { phone: this.bizumDirectPhone, okFn: () => { this.goToSuccessRoute() } })
      } else {
        this.goToSuccessRoute()
      }
    },
    goToSuccessRoute (params = {}) {
      this.$router.push({ path: APPOINTMENTS_ROUTE, query: { paymentSuccess: true, transactionType: 1, ...params } })
    },
    goToErrorRoute () {
      this.$router.push({ path: APPOINTMENTS_ROUTE, query: { paymentSuccess: false } })
    },
    onFreeAppointmentOrBizumDirect (data) {
      this.promotionCode = data.promotionCode
      this.bizumDirectPhone = data.bizumDirectPhone
      this.createAppointment()
    },
    onQueueOptionSelected () {
      if (!this.chooseQueueSelector.value) {
        this.$store.dispatch('showInfoAlert', this.$t('selectAnOption'))
        return
      }
      this.showChooseCompaniesQueueModal = false
      if (this.chooseQueueSelector.value === QUEUE_OPTION_WAIT) {
        this.showWarningDisableQueueModal()
      } else {
        this.$store.commit('appointmentRequest/setQueueDisabled', false)
        if ((!this.$store.state.appointmentRequest.appointmentData.customizedQueue && (this.appointmentType === CHAT || this.appointmentType === CALL)) || URGENT_QUEUE_SPECIALTIES.includes(this.profSpecialty)) {
          this.showUrgentQueueModal()
        } else {
          this.chooseQueueFinalStep()
        }
      }
    },
    showWarningDisableQueueModal () {
      this.modal.content = this.$t('warningChooseDisableQueue')
      this.modal.okBtnText = this.$t('continue')
      this.modal.okFn = () => {
        this.$store.commit('appointmentRequest/setQueueDisabled', true)
        if (URGENT_QUEUE_SPECIALTIES.includes(this.profSpecialty)) {
          setTimeout(() => {
              this.showUrgentQueueModal()
          }, 500)
        } else {
            this.chooseQueueFinalStep()
        }
      }
      this.modal.cancelBtnText = this.$t('cancel')
      this.modal.cancelFn = () => { }
      this.modal.show = true
    },
    showUrgentQueueModal () {
      this.modal.content = this.$t('urgentRequestQuestion')
      this.modal.okBtnText = this.$t('yes')
      this.modal.okFn = () => {
        this.$store.commit('appointmentRequest/setUrgentQueue', true)
        this.chooseQueueFinalStep()
      }
      this.modal.cancelBtnText = this.$t('no')
      this.modal.cancelFn = () => {
        this.$store.commit('appointmentRequest/setUrgentQueue', false)
        this.chooseQueueFinalStep()
      }
      this.modal.show = true
    },
    chooseQueueFinalStep () {
      if (this.freeAppointment) {
        this.createAppointment()
      } else {
        this.initPayment()
      }
    },
    initPayment () {
      if (CONSULTATIONS_REQUIRE_PAYMENT.some(id => id === this.$store.state.appointmentRequest.initData.appointmentType)) {
        this.$router.push({ name: PAYMENT_VIEW })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/appointment-request/AppointmentRequestView.vue